/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/course-complete',['require','jquery','core/overlay-screen','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var OverlayScreen = require('core/overlay-screen');
  var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var CourseComplete = OverlayScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    onBeforeShow: function()
    {
      this.$el.find('[data-id=print-btn]').on('click', $.proxy(function() {
        this.radio.trigger('print.cert');
      }, this));

      if (Engine.config.mapSettings.showCert === false)
        this.$el.find('[data-id=print-btn]').hide();

      this.$el.find('[data-id=survey-btn] a').attr('href', this.model.get('survey'));

      OverlayScreen.prototype.onBeforeShow.apply(this, arguments);
    },

    onShow: function()
    {
      this.finish();
    },

  /*****************************************************************************************************************///}

  });

  return CourseComplete;

});

